function handleSidebarFilter() {
  const filterWrapper = document.getElementById("ombrazFilterWrapper");
  if (!filterWrapper || filterWrapper.dataset.filterShellInit === "true") return null;

  const filterHeader = filterWrapper.querySelector(".ombraz-filter-header");
  const filterToggle = filterWrapper.querySelector(".ombraz-filter-toggle");
  const sidebar = filterWrapper.querySelector(".ombraz-sidebar");

  if (!filterHeader || !sidebar) return null;

  filterWrapper.dataset.filterShellInit = "true";

  const STYLE_ID = "ombraz-filter-mobile-runtime-style";
  let runtimeStyle = document.getElementById(STYLE_ID);
  if (!runtimeStyle) {
    runtimeStyle = document.createElement("style");
    runtimeStyle.id = STYLE_ID;
    runtimeStyle.textContent = `
      .ombraz-filter-wrapper.is-full-screen {
        position: fixed;
        top: var(--ombraz-filter-top-offset, 0px);
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1201;
        background: white;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        height: calc(100dvh - var(--ombraz-filter-top-offset, 0px));
        min-height: calc(100dvh - var(--ombraz-filter-top-offset, 0px));
      }

      .ombraz-filter-wrapper.is-full-screen .ombraz-sidebar {
        display: block;
        flex: 1;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        height: calc(100dvh - var(--ombraz-filter-top-offset, 0px));
        min-height: calc(100dvh - var(--ombraz-filter-top-offset, 0px));
      }

      .ombraz-filter-wrapper.is-full-screen .ombraz-filter-header {
        flex: 0 0 auto;
      }

      body.filter-active {
        overflow: hidden;
        position: fixed;
        top: var(--scroll-position, 0px);
        left: 0;
        right: 0;
        width: 100%;
      }
    `;
    document.head.appendChild(runtimeStyle);
  }

  const getViewportHeight = () =>
    window.innerHeight || document.documentElement.clientHeight || 0;

  const isElementRendered = (element) => {
    if (!element) return false;

    const styles = window.getComputedStyle(element);
    if (styles.display === "none" || styles.visibility === "hidden") return false;

    const rect = element.getBoundingClientRect();
    return rect.height > 0 && rect.width > 0;
  };

  const getAnnouncementElement = () =>
    document.querySelector(".ombraz-abtest-announcement") ||
    document.querySelector("#shopify-section-announcement-bar") ||
    document.querySelector(".announcement-bar");

  const getVisibleViewportHeight = (element) => {
    if (!isElementRendered(element)) return 0;

    const rect = element.getBoundingClientRect();
    const viewportHeight = getViewportHeight();
    if (viewportHeight <= 0) return 0;

    const visibleTop = Math.max(rect.top, 0);
    const visibleBottom = Math.min(rect.bottom, viewportHeight);
    const visibleHeight = visibleBottom - visibleTop;

    return Math.max(0, Math.round(visibleHeight));
  };

  const getAnnouncementHeight = () =>
    getVisibleViewportHeight(getAnnouncementElement());

  const getStickyHeaderHeight = () => {
    const stickyHeader = document.querySelector(".sticky-header");
    if (!stickyHeader) return 0;

    const isFixed = stickyHeader.classList.contains("sticky-header--fixed");
    const isHidden = stickyHeader.classList.contains("sticky-header--hidden");
    if (!isFixed || isHidden) return 0;

    return getVisibleViewportHeight(stickyHeader);
  };

  const getHeaderNewHeight = () => {
    const headerNew = document.querySelector(".header-new");
    if (!headerNew) return 0;

    return getVisibleViewportHeight(headerNew);
  };

  const getFallbackHeaderHeight = () => {
    const hasKnownHeader =
      document.querySelector(".sticky-header") || document.querySelector(".header-new");
    if (hasKnownHeader) return 0;

    return getVisibleViewportHeight(document.querySelector("header"));
  };

  const updateTopOffset = () => {
    const announcementHeight = getAnnouncementHeight();
    const totalHeight =
      announcementHeight +
      getStickyHeaderHeight() +
      getHeaderNewHeight() +
      getFallbackHeaderHeight();

    filterWrapper.style.setProperty("--ombraz-filter-top-offset", `${totalHeight}px`);
  };

  let topOffsetRafId = null;
  const scheduleTopOffsetUpdate = () => {
    if (topOffsetRafId !== null) return;

    topOffsetRafId = window.requestAnimationFrame(() => {
      topOffsetRafId = null;
      updateTopOffset();
    });
  };

  let savedScrollPosition = 0;

  const updateChevronState = (isExpanded) => {
    if (!filterToggle) return;

    filterToggle.setAttribute("aria-expanded", isExpanded.toString());
    const icon = filterToggle.querySelector(".ombraz-icon");
    if (!icon) return;

    icon.classList.toggle("ombraz-icon-chevron-up", isExpanded);
    icon.classList.toggle("ombraz-icon-chevron-down", !isExpanded);
  };

  const openSidebar = () => {
    updateTopOffset();
    sidebar.classList.add("active");
    filterWrapper.classList.add("is-full-screen");

    savedScrollPosition = window.scrollY;
    document.documentElement.style.setProperty(
      "--scroll-position",
      `-${savedScrollPosition}px`
    );
    document.body.classList.add("filter-active");

    updateChevronState(true);
  };

  const closeSidebar = () => {
    sidebar.classList.remove("active");
    filterWrapper.classList.remove("is-full-screen");
    document.body.classList.remove("filter-active");

    const scrollPositionValue = document.documentElement.style.getPropertyValue(
      "--scroll-position"
    );
    document.documentElement.style.removeProperty("--scroll-position");

    const parsedScrollPosition = Number.parseInt(scrollPositionValue, 10);
    const restorePosition = Number.isFinite(parsedScrollPosition)
      ? Math.abs(parsedScrollPosition)
      : savedScrollPosition;
    window.scrollTo(0, restorePosition);

    updateChevronState(false);
  };

  const toggleSidebar = () => {
    if (sidebar.classList.contains("active")) {
      closeSidebar();
    } else {
      openSidebar();
    }
  };

  const onHeaderClick = () => {
    toggleSidebar();
  };

  const onDocumentClick = (event) => {
    if (!sidebar.classList.contains("active")) return;

    if (!filterWrapper.contains(event.target)) {
      closeSidebar();
    }
  };

  const onDocumentKeydown = (event) => {
    if (event.key === "Escape" && sidebar.classList.contains("active")) {
      closeSidebar();
    }
  };

  const onSidebarTouchMove = (event) => {
    event.stopPropagation();
  };

  updateTopOffset();
  updateChevronState(sidebar.classList.contains("active"));

  filterHeader.addEventListener("click", onHeaderClick);
  document.addEventListener("click", onDocumentClick);
  document.addEventListener("keydown", onDocumentKeydown);
  sidebar.addEventListener("touchmove", onSidebarTouchMove, { passive: true });
  window.addEventListener("resize", scheduleTopOffsetUpdate, { passive: true });
  window.addEventListener("orientationchange", scheduleTopOffsetUpdate, {
    passive: true,
  });
  window.addEventListener("scroll", scheduleTopOffsetUpdate, { passive: true });

  return () => {
    filterHeader.removeEventListener("click", onHeaderClick);
    document.removeEventListener("click", onDocumentClick);
    document.removeEventListener("keydown", onDocumentKeydown);
    sidebar.removeEventListener("touchmove", onSidebarTouchMove);
    window.removeEventListener("resize", scheduleTopOffsetUpdate);
    window.removeEventListener("orientationchange", scheduleTopOffsetUpdate);
    window.removeEventListener("scroll", scheduleTopOffsetUpdate);

    if (topOffsetRafId !== null) {
      window.cancelAnimationFrame(topOffsetRafId);
      topOffsetRafId = null;
    }

    sidebar.classList.remove("active");
    filterWrapper.classList.remove("is-full-screen");
    filterWrapper.style.removeProperty("--ombraz-filter-top-offset");
    document.body.classList.remove("filter-active");
    document.documentElement.style.removeProperty("--scroll-position");
    updateChevronState(false);

    delete filterWrapper.dataset.filterShellInit;
  };
}

function initializeOnLoad() {
  const isTabletOrMobile = window.matchMedia("(max-width: 1199px)").matches;
  if (!isTabletOrMobile) return;

  const cleanup = handleSidebarFilter();
  if (typeof cleanup === "function") {
    window.addEventListener("unload", cleanup, { once: true });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeOnLoad, { once: true });
} else {
  initializeOnLoad();
}
